var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPromaxPricing = function SvgIconPromaxPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_promax_pricing_svg__a)",
    d: "M15.105 10 12 22.5 8.895 10zm-3.96-7.501L9.022 8.333h5.954l-2.121-5.834zm5.605 5.834h5.118a2.5 2.5 0 0 0-.333-.667l-2.943-4.12A2.5 2.5 0 0 0 16.558 2.5h-1.929zm.071 1.666-2.304 9.417 6.95-8.75a2.5 2.5 0 0 0 .367-.667zM7.18 10H2.166q.134.362.371.667l6.946 8.75zm.07-1.666 2.122-5.834H7.442a2.5 2.5 0 0 0-2.034 1.048L2.465 7.666a2.5 2.5 0 0 0-.333.667z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_promax_pricing_svg__a",
    x1: 9.955,
    x2: 14.352,
    y1: 9.448,
    y2: 26.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconPromaxPricing;